import { createAction, createSlice } from "@reduxjs/toolkit";

const uploadImageSlice = createSlice({
  name: "uploadImage",
  initialState: { url: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.url = action.payload.url;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = uploadImageSlice;
const uploadImageAction = createAction(name);

export {
  uploadImageAction,
  actions as uploadImageActions,
  reducer as uploadImageReducer,
};
